var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#DED8FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64202 8.46425H16.8225L14.7085 6.35113L15.5349 5.51782L19.0706 9.05354L15.5349 12.5893L14.7085 11.7556L16.8208 9.64282H9.64202C8.70429 9.64282 7.80497 10.0153 7.14189 10.6784C6.47882 11.3415 6.10631 12.2408 6.10631 13.1785C6.10631 14.1163 6.47882 15.0156 7.14189 15.6787C7.80497 16.3417 8.70429 16.7143 9.64202 16.7143H14.3563V17.8928H9.64202C8.39171 17.8928 7.19262 17.3961 6.30852 16.512C5.42442 15.6279 4.92773 14.4288 4.92773 13.1785C4.92773 11.9282 5.42442 10.7291 6.30852 9.84503C7.19262 8.96093 8.39171 8.46425 9.64202 8.46425V8.46425Z",
    fill: "#020002"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedoIcon);
export default __webpack_public_path__ + "static/media/redoIcon.10adabaf0bfcf0541badecba8667f980.svg";
export { ForwardRef as ReactComponent };